import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { MutliselectComponent } from './mutliselect.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SelectDropDownModule,
  ],
  exports: [
    MutliselectComponent
  ],
  declarations: [MutliselectComponent]
})
export class MutliselectModule { }
